import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';
import { UserRouteAccessCrudService } from '../../shared';
// import { JhiPaginationUtil } from 'ng-jhipster';

import {CONFIG} from '../../shared/constants/config.constants';

// import { AnnouncementtPopupComponent } from './Announcement-dialog.component/Announcement-dialog.component';
// import { AnnouncementAdjustmentComponent } from './Announcement-adjustment/Announcement-adjustment.component';
// import { ItemPreviewAnnouncementPopupComponent } from './Announcement-preview/Announcement-preview.component';

@Injectable()
export class AnnouncementEditResolvePagingParams implements Resolve<any> {

    constructor() {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        const sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,desc';
        return {
            // page: this.paginationUtil.parsePage(page),
            // predicate: this.paginationUtil.parsePredicate(sort),
            // ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}

@Injectable()
export class AnnouncementResolvePagingParams implements Resolve<any> {

    constructor() {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        const sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'name,asc';
        return {
            // page: this.paginationUtil.parsePage(page),
            // predicate: this.paginationUtil.parsePredicate(sort),
            // ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}

export const AnnouncementRoute: Routes = [
    
];